import styled from "styled-components";

export const WrapperFooter = styled.div`
  margin-top: 5rem;
  height: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 2px solid rgba(34, 34, 34, 0.15);
  font-size: 1.1rem;
  font-family: Apple-System, Arial, Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', STXihei, sans-serif;
  color: #606060;
`
